
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const recurringbonusApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listRecurringBonuss: builder.query ({
      query: (params) => `v2/recurringbonus/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["RecurringBonus"]
    }),
    getRecurringBonus: builder.query ({
      query: (recurringbonus_id) => `v2/recurringbonus/${recurringbonus_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["RecurringBonus"]
    }),

    updateRecurringBonus: builder.mutation ({
      query: ({recurringbonus_id, data}) => ({
        url: `v2/recurringbonus/${recurringbonus_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["RecurringBonus"]
    }),
    deleteRecurringBonus: builder.mutation ({
      query: (recurringbonus_id) => ({
        url: `v2/recurringbonus/${recurringbonus_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["RecurringBonus"]
    }),
    createRecurringBonus: builder.mutation ({
      query: (data) => ({
        url: `v2/recurringbonus/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["RecurringBonus"]
    }),
  })
})


export const {
  useListRecurringBonussQuery,
  useLazyListRecurringBonussQuery,
  useGetRecurringBonusQuery,
  useLazyGetRecurringBonusQuery,

  useUpdateRecurringBonusMutation,
  useDeleteRecurringBonusMutation,
  useCreateRecurringBonusMutation
} = recurringbonusApi
